<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="800px"
  >
    <!--<editor-fold desc="Dialog Header">-->
    <template slot="dialogTitle">
      <span v-if="commentDirty.id">
        Edit Comment
      </span>
      <span v-else>
        Add New Comment
      </span>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Form">-->
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <v-textarea
        v-model="commentDirty.comment"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-btn
        small
        outlined
        color="error"
        @click="toggleConfirmationDialog(true)"
      >
        <v-icon
          left
          small
        >
          delete
        </v-icon>
        Delete
      </v-btn>
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      text="Are you sure you want to delete this Comment?"
      @confirmed="deleteComment"
    />
  </content-dialog>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import Comment from '@/models/Comment'
  import ContentDialog from '@/components/helpers/Dialog'
  import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
  import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'

  export default {
    name: 'CommentEditDialog',
    components: {
      ContentDialog,
      ConfirmDeleteDialog
    },
    mixins: [deleteConfirmationMixin],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      comment: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        commentDirty: cloneDeep(Comment.emptyModel),
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    watch: {
      comment() {
        this.commentDirty = cloneDeep(this.comment)
      }
    },
    methods: {
      async submit() {
        let validated = await this.$validator.validate()

        if (!validated) return

        this.save()
      },
      async save() {
        this.submitting = true

        const data = {
          comment: this.commentDirty.comment,
          commentable_type: this.commentDirty.commentable_type,
          commentable_id: this.commentDirty.commentable_id
        }

        try {
          let comment = await Comment.api.save(data, this.commentDirty.id)

          this.$store.dispatch('alert', {
            'text': 'Comment saved',
            'color': 'success'
          })
          this.modalVisible = false
          this.$emit(this.commentDirty.id ? 'comment:updated' : 'comment:created', comment)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        } finally {
          this.submitting = false
        }
      },
      async deleteComment() {
        this.deleting = true

        try {
          await Comment.api.destroy(this.commentDirty.id)

          this.$store.dispatch('alert', {
            'text': 'Comment deleted',
            'color': 'info'
          })
          this.modalVisible = false
          this.$emit('comment:deleted', this.commentDirty.id)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.deleteConfirmationDialogVisible = false
          this.deleting = false
        }
      }
    }
  }
</script>
